// 🔧 categories.js
// ✅ Purpose: Category template for the SAP NOW Milan AI Agents Challenge Experience
// ✅ Features:
// - Defines the single challenge category used by all thirteen demo partners
// - Keeps judging criteria separate from categories; criteria are added in Enhancement 5C
// - Supports the existing Experience Factory category-generation contract
// - Uses neutral reusable data without claiming real SAP partner participation
// - Fully block-commented for clarity and future devs

export const SAP_AI_AGENTS_CHALLENGE_CATEGORIES = [
  {
    name: "AI Agents Challenge",

    description:
      "SAP partner demonstrations competing in the SAP NOW Milan AI Agents Challenge.",
  },
];